import * as PixelsmithBlocks from '../blocks';
import * as PixelsmithModules from './js';

const ModulesAndBlocks = { ...PixelsmithModules, ...PixelsmithBlocks };

/** Converts numeric degrees to radians */
if (typeof Number.prototype.toRad === 'undefined') {
	Number.prototype.toRad = function () {
		return (this * Math.PI) / 180;
	};
}

window.addEventListener('DOMContentLoaded', (ev) => {
	$ = jQuery.noConflict();

	for (const key in ModulesAndBlocks) {
		// Initialize modules/blocks on the frontend (i.e. when window.acf is undefined)
		if (Object.hasOwnProperty.call(ModulesAndBlocks, key) && !window.acf)
			ModulesAndBlocks[key].init();

		// Make sure blocks JS render properly in the editor (cf. https://www.advancedcustomfields.com/resources/acf_register_block_type/)
		if (window.acf && Object.hasOwnProperty.call(PixelsmithBlocks, key))
			window.acf.addAction(
				`render_block_preview/type=${PixelsmithBlocks[key].name}`,
				PixelsmithBlocks[key].init
			);
	}
});
